import React from 'react'
import MediaQuery from 'react-responsive'
import * as Helpers from '../components/helpers'
import PropTypes from 'prop-types'

//Assets
import closeWhite from '../assets/close-white.svg'
import logo from '../assets/logo.svg'
import hamburger from '../assets/hamburger.svg'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
    }
  }
  componentWillMount() {}

  toggleMenu() {
    this.setState({
      menuOpen: !this.state.menuOpen,
    })
  }
  handleLangSwitch(e, link) {
    e.preventDefault()
    console.log(link.split('/')[1])
    let lang = link.split('/')[1]
    localStorage.setItem('setLang', lang === '' ? 'cs' : lang)
    window.location = link
  }
  render() {
    return (
      <div className="header">
        <div className="cont flex flex-v-center flex-space-betwean">
          <div className="g-20 pr">
            <div className="hp-lines">
              <div className="hp-line" />
              <div className="hp-line" />
              <div className="hp-line" />
              <div className="hp-line" />
              <div className="hp-line" />
              <div className="hp-line" />
            </div>
            <a href="#">
              <img className="pr z10" src={logo} alt="Distributa.io" />
            </a>
          </div>

          <MediaQuery query="(max-width: 725px)">
            <div className="header-hamburger">
              <img
                onClick={this.toggleMenu.bind(this)}
                src={hamburger}
                alt="menu icon"
              />
            </div>
          </MediaQuery>

          <div
            className={
              'g-80 gm-100 mobile-menu ' +
              (this.state.menuOpen ? 'menu-open' : 'menu-close')
            }
          >
            <MediaQuery query="(max-width: 725px)">
              <img
                onClick={this.toggleMenu.bind(this)}
                src={closeWhite}
                alt="menu close"
              />
            </MediaQuery>
            <nav>
              {this.props.links.map((el, i) => {
                return (
                  <NavItem
                    key={i}
                    toggleMenu={this.toggleMenu.bind(this)}
                    link={el.link}
                    active={el.active}
                  >
                    {el.label}
                  </NavItem>
                )
              })}
              <LangItem onClick={this.handleLangSwitch.bind(this)} link="/">
                CZ
              </LangItem>
              <LangItem onClick={this.handleLangSwitch.bind(this)} link="/en">
                EN
              </LangItem>
            </nav>
          </div>
        </div>
      </div>
    )
  }
}

const NavItem = props => (
  <a
    className={(props.active ? 'active' : '') + ' bold upper fs14'}
    href={'#' + props.link}
    onClick={() => {
      props.toggleMenu()
      Helpers.SmoothScroll.scrollTo(props.link)
    }}
  >
    {props.children}
  </a>
)

const LangItem = props => (
  <a
    className={(props.active ? 'active' : '') + ' bold upper fs14'}
    href={'#' + props.link}
    onClick={e => {
      props.onClick(e, props.link)
    }}
  >
    {props.children}
  </a>
)

NavItem.propTypes = {
  link: PropTypes.string.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js